import Link from 'next/link';
import css from '../sass/sitestyle.scss';
import daysAgo from '../utils/daysago';

const timeNow = () => {
  return new Date().getTime() / 1000;
};

const BurgerItem = ({ burger }) => (
  <article className={css['burger-panel']}>
    <Link as={`/b/${burger.burgerID}`} href={`/post?id=${burger.burgerID}`}>
      <a className={css['burger-photo-link']} aria-label={`View ${burger.burgerName}`}>
        <img
          src={`/image/${burger['img:iconName']}`}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = '/image/fallback/burger-fallback.svg';
          }}
          className={css['burger-icon']}
          alt={burger.burgerName || 'Burger'}
        />
        <span className={css['burger-score']}>
          <strong>{burger.burgerScore}</strong>
          <small>score</small>
        </span>
      </a>
    </Link>
    <input
      className={css['burger-lat']}
      type="hidden"
      name="lat"
      value={burger.lat}
    />
    <input
      className={['burger-long']}
      type="hidden"
      name="long"
      value={burger.long}
    />

    <div className={css['burger-stats']}>
      <Link as={`/b/${burger.burgerID}`} href={`/post?id=${burger.burgerID}`}>
        <a className={css['burger-card-title']}>{burger.burgerName}</a>
      </Link>
      <p className={css['burger-meta']}>
        {burger.restaurantName || 'Restaurant unknown'} ·{' '}
        {daysAgo(timeNow() - burger.dateEaten)}
      </p>
      <div className={css['score-grid']}>
        <span><small>Meat</small><strong>{burger.meatRating}</strong></span>
        <span><small>Bun</small><strong>{burger.bunRating}</strong></span>
        <span><small>Toppings</small><strong>{burger.toppingRating}</strong></span>
        <span><small>Sides</small><strong>{burger.sideRating || 0}</strong></span>
      </div>
    </div>
  </article>
);

export default BurgerItem;



// WEBPACK FOOTER //
// components/BurgerItem.js